import React, { useState } from 'react';
import { Formik, Form, FieldArray } from 'formik';
import { post } from 'axios';

import { actionSvgs } from 'assets/icons';

import FilledButton from 'components/Buttons/FilledButton';
import ModalContiner from 'components/ModalContainer';

import { renderToast } from 'components/Informations/Toast/utils';

import { ArrUniq } from 'utils/core';

import endpoints from 'services/endpoints';

import * as Yup from 'yup';
import * as S from './styles';

const Add = () => actionSvgs('add');
const Delete = () => actionSvgs('remove');

const { updateQuestion } = endpoints;

export default function LenguageModalQuestions({ data, open, setOpen, type }) {
  const { id_area, id_bloco, id_funcionario: idFuncionario, observer } = data;

  const [toastVisibility, setToastVisibility] = useState(false);
  const [toastInfos, setToastInfos] = useState({
    type: '',
    message: '',
    autoClose: 6000,
  });

  const allAlternativas = ArrUniq(
    data?.questoes.flatMap(i => i.alternativas),
    i => i
  );

  const opcoesResposta = ArrUniq(
    data?.questoes.flatMap(i => i.opcoes_resposta),
    o => o?.descricao
  );

  const initialValues = {
    name: data.nome,
    opcao_resposta: opcoesResposta,
    options: data?.questoes.map(d => ({ nome: d.nome })) || [{ nome: '' }],
  };

  const schema = Yup.object().shape({
    name: Yup.string()
      .min(3, 'Campo obrigatório')
      .required('Campo obrigatório'),

    opcao_resposta: Yup.array().of(
      Yup.object().shape({
        descricao: Yup.string()
          .min(3, 'Campo obrigatório')
          .required('Campo obrigatório'),
      })
    ),

    options: Yup.array().of(
      Yup.object().shape({
        nome: Yup.string()
          .min(3, 'Campo obrigatório')
          .required('Campo obrigatório'),
      })
    ),
  });

  const handleSubmit = (values, { resetForm }) => {
    const objectToSend = {
      id_area,
      id_bloco,
      id_usr_up: idFuncionario,
      idioma: 1,
      questoes: values.options?.map(({ nome }) => nome),
      id_tipo_questao: 2,
      alternativas: values.opcao_resposta?.map(({ descricao }) => descricao),
    };

    return post(updateQuestion, objectToSend)
      .then(() => {
        setToastVisibility(true);
        setToastInfos({
          type: 'success',
          message: 'Questões atualizadas com sucesso',
          autoClose: 6000,
        });
      })
      .then(() => {
        setTimeout(() => {
          resetForm();
          observer();
          setOpen(false);
        }, 4000);
      })
      .catch(() => {
        setToastVisibility(true);
        setToastInfos({
          type: 'error',
          message: 'Erro ao atualizar questões',
          autoClose: 6000,
        });
      });
  };

  return (
    <>
      {toastVisibility &&
        renderToast(
          toastInfos.type,
          toastInfos.message,
          toastInfos.autoClose,
          setToastVisibility
        )}

      <ModalContiner
        isOpen={open}
        setIsOpen={setOpen}
        headText="Editar Idiomas"
      >
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, setFieldValue, resetForm }) => (
            <Form>
              <S.FormField
                label="Bloco"
                label_for="block-name"
                error={!!errors.name?.length && errors.name}
                error_message={!!errors.name?.length && errors.name}
              >
                <S.FormInput
                  id="block-name"
                  name="nome"
                  value={values.name}
                  onChange={e => setFieldValue('name', e.target.value)}
                  error={!!errors.name?.length && errors.name}
                />
              </S.FormField>

              <FieldArray
                name="options"
                render={arrayHelpers =>
                  values.options?.map((item, i) => (
                    <S.FormRow
                      error={
                        !!errors?.options?.length && !!errors?.options[i]?.nome
                      }
                    >
                      <S.FormField
                        label={i === 0 && 'Idiomas'}
                        label_for={`nome_${i}`}
                        error={
                          !!errors.options?.length && errors.options[i]?.nome
                        }
                        error_message={
                          !!errors.options?.length && errors.options[i]?.nome
                        }
                      >
                        <S.FormInput
                          id={`nome_${i}`}
                          name="nome"
                          value={item.nome}
                          onChange={e =>
                            setFieldValue(`options[${i}].nome`, e.target.value)
                          }
                          error={
                            !!errors.options?.length && errors.options[i]?.nome
                          }
                        />
                      </S.FormField>
                      {values.options?.length - 1 > 0 && (
                        <S.FormButton
                          className="icon"
                          kind={
                            values.options?.length - 1 === 0
                              ? 'disbled'
                              : 'cancel'
                          }
                          icon={Delete}
                          disabled={values.options?.length - 1 === 0}
                          onClick={e => {
                            e.preventDefault();
                            arrayHelpers.remove(i);
                          }}
                        />
                      )}
                      {values.options?.length - 1 === i && (
                        <S.FormButton
                          className="icon"
                          kind="primary"
                          icon={Add}
                          onClick={e => {
                            e.preventDefault();
                            arrayHelpers.insert(i + 1, { nome: '' });
                          }}
                        />
                      )}
                    </S.FormRow>
                  ))
                }
              />
              <FieldArray
                name="opcao_resposta"
                render={() =>
                  values.opcao_resposta?.map((item, i) => (
                    <S.FormRow
                      error={
                        !!errors.opcao_resposta?.length &&
                        !!errors.opcao_resposta[i]?.descricao
                      }
                    >
                      <S.FormField
                        label={i === 0 && 'Alternativas'}
                        label_for={`level_${i}`}
                        error={
                          !!errors.opcao_resposta?.length &&
                          errors.opcao_resposta[i]?.descricao
                        }
                        error_message={
                          !!errors.opcao_resposta?.length &&
                          errors.opcao_resposta[i]?.descricao
                        }
                      >
                        <S.FormInput
                          id={`level_${i}`}
                          name="type"
                          value={item?.descricao}
                          onChange={e =>
                            setFieldValue(
                              `opcao_resposta[${i}].descricao`,
                              e.target.value
                            )
                          }
                          error={
                            !!errors.opcao_resposta?.length &&
                            errors.opcao_resposta[i]?.descricao
                          }
                        />
                      </S.FormField>
                    </S.FormRow>
                  ))
                }
              />

              <S.ButtonsWrap>
                <FilledButton
                  text="Cancelar"
                  buttonClass="cancel"
                  handleClick={e => {
                    e.preventDefault();
                    resetForm();
                    setOpen(false);
                  }}
                />
                <FilledButton
                  text="enviar"
                  buttonType="submit"
                  buttonClass="confirm"
                />
              </S.ButtonsWrap>
            </Form>
          )}
        </Formik>
      </ModalContiner>
    </>
  );
}
